<template>
    <v-layout wrap>
        <v-flex xs12 shrink>
            <div class="body-1 text-xs-center">
                <slot>
                    <div>{{firstLine}}</div>
                    <div v-if="creationRouteName">
                        <span>{{$t('modules.blocks.page.m-block-empty-page-content.creationText.part1')}}  </span>
                        <span>
                            <e-link-nav :to="{name:creationRouteName}">
                                <e-button-primary-plus class="ma-0"/>
                            </e-link-nav>
                            <e-button-primary-plus class="ma-0"  v-if="creationAction" @click="creationAction"/>
                        </span>
                        <span> {{$t('modules.blocks.page.m-block-empty-page-content.creationText.part2')}}</span>
                    </div>
                </slot>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "m-block-empty-page-content",
        props:{
            line1Text:{
                type: String,
                default: ''
            },
            creationRouteName:{
                type: String
            },
            creationAction:{
                type: Function
            },
            addFilter:{  // used to resize the Sort-Select when Filter appears
                type: Boolean,
                default: false
            }
        },
        computed:{
            firstLine(){
                return this.line1Text || this.$t('modules.blocks.page.m-block-empty-page-content.creationText.firstLine')
            }
        }
    }
</script>

<style scoped lang="scss">
   //
</style>
